import React from "react";
import { useAtom } from "jotai";
import {
    activeCategoryAtom,
    activeProvidersAtom,
    providersAtom,
    showProvidersAtom,
} from "../state/games";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";
import Modal from "react-modal";
import { Button } from "@mui/material";
import { CloseIcon } from "./Icons";
import Icon from "./Icon";

const ProvidersGrid = () => {
    const handleLinkClick = (route: string, provider_id: number) => {
        if (location.pathname === routes.root || location.pathname.startsWith("/games")) {
            setActiveProviders([provider_id]);
            setActiveCategory(0);
            setShowProviders(false);
            navigate(routes.pages.games);
        } else {
            window.location.href = "/#" + route;
        }
    };
    const [providers] = useAtom(providersAtom);
    const [showProviders, setShowProviders] = useAtom(showProvidersAtom);
    const [activeProviders, setActiveProviders] = useAtom(activeProvidersAtom);
    const [, setActiveCategory] = useAtom(activeCategoryAtom);
    const navigate = useNavigate();
    const customStyles = {
        overlay: {
            zIndex: 2147483647,
            background: "rgba(15, 20, 50, 0.7)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
        },
        content: {
            background: "rgba(15, 20, 50, 0.7)",
            border: 0,
            borderRadius: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            overflow: "hidden auto",
        },
    };
    const closeModal = () => {
        setShowProviders(false);
    };
    return (
        <Modal
            isOpen={showProviders}
            contentLabel="Modal"
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            style={customStyles}
        >
            <div className="providers-grid-wrapper">
                <Button
                    sx={{
                        position: "fixed",
                        right: "30px",
                        top: "15px",
                        minWidth: 0,
                        borderRadius: "50%",
                        backgroundColor: "#030511",
                        padding: "5px",
                        border: "1px solid #fff",
                        svg: {
                            width: "20px",
                            height: "20px",
                            stroke: "#fff",
                            strokeWidth: "2px",
                        },
                    }}
                    onClick={() => closeModal()}
                >
                    <Icon icon={CloseIcon} />
                </Button>
                <div className="providers-grid flex">
                    {providers &&
                        providers.map(provider => {
                            return (
                                <div
                                    key={provider.id}
                                    className={
                                        activeProviders.includes(provider.id)
                                            ? "provider active"
                                            : "provider"
                                    }
                                    onClick={() => handleLinkClick(routes.pages.games, provider.id)}
                                >
                                    <svg className="provider_svg">
                                        <use href={`#${provider.slug}-c`}></use>
                                    </svg>
                                    <span className="provider-title">{provider.name}</span>
                                </div>
                            );
                        })}
                </div>
            </div>
        </Modal>
    );
};

export default ProvidersGrid;
